import React from 'react'
import Navbar from '../LandingPage/Navbar'
import { Footer } from '../LandingPage/Footer'

function Terms() {
	const baseStyle = 'max-w-4xl mx-auto p-5 text-gray-700 bg-white'

	return (
		<div data-theme="light" className="min-h-screen bg-white pt-28">
			<Navbar minimal />
			<div className={baseStyle}>
			<div className="max-w-4xl mx-auto p-5">
				<div className="container">
					<div
						className="tab-content translations-content-item en visible"
						id="en"
					>
						<h2 className="text-3xl font-bold text-gray-900 mb-4">
							Terms and Conditions for LoadFetcher
						</h2>

						<p className="text-md mb-2 text-gray-600">
							Last updated: October 10, 2025
						</p>

						<section className="mb-6">
							<p className="text-gray-700 mb-3">
								Please read these Terms and Conditions carefully before using
								LoadFetcher (the "Service") operated by Fierce Trade LLC ("us",
								"we", or "our").
							</p>
							<p className="text-gray-700 mb-3">
								Your access to and use of the Service is conditioned on your
								acceptance of and compliance with these Terms. These Terms apply
								to all visitors, users and others who access or use the Service.
							</p>
							<p className="text-gray-700 mb-3">
								By accessing or using the Service you agree to be bound by these
								Terms. If you disagree with any part of the terms then you may
								not access the Service.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Definitions
							</h2>
							<p className="text-gray-700 mb-3">
								For the purposes of these Terms and Conditions:
							</p>
							<ul>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Service</strong> refers to LoadFetcher, a freight
										load aggregation and search platform, accessible from
										https://loadfetcher.com
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Company</strong> (referred to as either "the
										Company", "We", "Us" or "Our" in this Agreement) refers to
										Fierce Trade LLC, 30 N Gould St. Ste R Sheridan, WY 82801.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>You</strong> means the individual accessing or using
										the Service, or the company, or other legal entity on behalf
										of which such individual is accessing or using the Service,
										as applicable.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Account</strong> means a unique account created for
										You to access our Service or parts of our Service.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Content</strong> refers to content such as text,
										images, data, or other information that can be posted,
										uploaded, linked to or otherwise made available by You,
										regardless of the form of that content.
									</p>
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Incorporation of Policies
							</h2>
							<p className="text-gray-700 mb-3">
								The following policies are incorporated by reference and form
								part of this Agreement: Privacy Policy (/policy), Acceptable Use
								Policy (included below), and any other policies we may publish.
								If a policy conflicts with these Terms, these Terms control.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Accounts and Registration
							</h2>
							<p className="text-gray-700 mb-3">
								When you create an account with us, you must provide us
								information that is accurate, complete, and current at all
								times. Failure to do so constitutes a breach of the Terms, which
								may result in immediate termination of your account on our
								Service.
							</p>
							<p className="text-gray-700 mb-3">
								You are responsible for safeguarding the password that you use
								to access the Service and for any activities or actions under
								your password, whether your password is with our Service or a
								third-party service.
							</p>
							<p className="text-gray-700 mb-3">
								You agree not to disclose your password to any third party. You
								must notify us immediately upon becoming aware of any breach of
								security or unauthorized use of your account.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Assent and Enforceability
							</h2>
							<p className="text-gray-700 mb-3">
								You agree to these Terms via a click-through box or other
								affirmative action indicating "I agree to the Terms & Privacy
								Policy," which creates an enforceable contract (clickwrap). We
								may require re-assent when we materially update these Terms.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Third-Party Platforms and No Affiliation
							</h2>
							<p className="text-gray-700 mb-3">
								The Service may interact with or aggregate data from third-party
								platforms, load boards, freight marketplaces, and other external
								services. We are not affiliated with, endorsed by, or sponsored
								by any third-party platforms.
							</p>
							<p className="text-gray-700 mb-3">
								You are solely responsible for complying with all third-party
								terms of service, usage policies, robots.txt files, rate limits,
								and applicable laws. We may suspend or terminate the Service,
								without liability to you, if we believe your use risks violation
								of third-party terms, creates legal risk for us, or violates
								applicable laws or regulations.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								User Responsibilities and Acceptable Use
							</h2>
							<h3 className="text-lg font-semibold text-gray-800 mb-3">
								Compliance with Third-Party Terms
							</h3>
							<p className="text-gray-700 mb-3">
								By using LoadFetcher's services, You acknowledge and agree that
								it is solely Your responsibility to ensure that Your use of the
								Service, including any data fetching, scraping, or interaction
								with third-party websites, complies with:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>The terms of service of third-party websites</li>
								<li>Usage policies and robots.txt files</li>
								<li>
									All applicable local, state, national, and international laws
									and regulations
								</li>
								<li>Any other applicable rules or restrictions</li>
							</ul>
							<p className="text-gray-700 mb-3">
								You are responsible for conducting Your own research and due
								diligence to determine whether Your intended use of the Service
								complies with all applicable requirements. LoadFetcher does not
								provide legal advice and makes no representations or warranties
								regarding the legality of Your use of the Service in relation to
								any specific website or jurisdiction.
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Acceptable Use Policy and Anti-Abuse
							</h3>
							<p className="text-gray-700 mb-3">You will not:</p>
							<ul className="text-gray-700 mb-3">
								<li>
									(a) Access or use the Service to violate any law, regulation,
									or third-party terms of service
								</li>
								<li>
									(b) Perform automated requests beyond your plan limits,
									circumvent technical measures, or interfere with Service
									integrity or availability
								</li>
								<li>
									(c) Reverse engineer, decompile, disassemble, or derive source
									code from the Service except to the extent permitted by
									applicable law
								</li>
								<li>
									(d) Probe, scan, or test the security of any system or network
									without our prior written permission
								</li>
								<li>
									(e) Resell, sublicense, share login credentials, or share
									results to enable third parties to bypass their own
									subscriptions
								</li>
								<li>
									(f) Use the Service to build a competing product or service,
									or to create a dataset for distribution or sale
								</li>
								<li>
									(g) Transmit viruses, worms, logic bombs, or other malicious
									or technologically harmful material
								</li>
								<li>
									(h) Impersonate any person or entity, or falsely state or
									misrepresent your affiliation with a person or entity
								</li>
								<li>
									(i) Attempt to gain unauthorized access to any part of the
									Service, other accounts, or connected systems
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								We may rate-limit, throttle, or immediately suspend access to
								protect the Service, our users, or third-party platforms.
								Suspended accounts may be subject to investigation and permanent
								termination.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Device and Rate Limits
							</h2>
							<p className="text-gray-700 mb-3">
								Plan-specific device, session, and request limits are enforced
								both technically and contractually. Your subscription plan
								defines the maximum number of concurrent devices, sessions, and
								API requests permitted.
							</p>
							<p className="text-gray-700 mb-3">
								Attempts to evade limits—including token sharing, rotating
								devices/IPs, using automation tools to simulate multiple users,
								or other circumvention techniques—constitute a material breach
								of these Terms and may result in immediate suspension or
								termination without refund.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Subscriptions, Billing, Taxes, and Price Changes
							</h2>
							<p className="text-gray-700 mb-3">
								Some parts of the Service are billed on a subscription basis
								("Subscription(s)"). You will be billed in advance on a
								recurring and periodic basis ("Billing Cycle"). Billing cycles
								are set either on a monthly or annual basis, depending on the
								type of subscription plan you select when purchasing a
								Subscription.
							</p>
							<p className="text-gray-700 mb-3">
								You authorize us to charge recurring fees for your selected
								Subscription to your payment method on file. Prices exclude all
								sales, use, value-added, and other taxes, duties, and government
								charges; you are responsible for all such amounts.
							</p>
							<p className="text-gray-700 mb-3">
								We may change prices or plan features with reasonable notice (at
								least 30 days for material price increases); changes apply at
								the next renewal. Where offered, free trials convert to paid
								subscriptions unless canceled before the trial end. Plan
								upgrades are prorated forward; downgrades take effect at the
								next billing cycle.
							</p>
							<p className="text-gray-700 mb-3">
								At the end of each Billing Cycle, your Subscription will
								automatically renew under the same conditions unless you cancel
								it or we cancel it. You may cancel your Subscription renewal
								through your online account management page or by contacting our
								customer support team at info@loadfetcher.com.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>Chargebacks:</strong> Disputing a valid charge
								(chargeback) may result in immediate suspension of your account
								and termination of the Service. If you believe you have been
								incorrectly billed, contact us at info@loadfetcher.com before
								initiating a chargeback.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Refund Policy
							</h2>
							<p className="text-gray-700 mb-3">
								Except when required by law, paid Subscription fees are
								non-refundable. We do not provide refunds or credits for any
								partial subscription periods, unused Service, or downgrades.
							</p>
							<p className="text-gray-700 mb-3">
								Where required by local law (e.g., EU consumer protection laws),
								statutory refund rights apply and supersede this section.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Intellectual Property
							</h2>
							<p className="text-gray-700 mb-3">
								The Service and its original content, features and functionality
								are and will remain the exclusive property of Fierce Trade LLC
								and its licensors. The Service is protected by copyright,
								trademark, and other laws of both the United States and foreign
								countries.
							</p>
							<p className="text-gray-700 mb-3">
								Our trademarks and trade dress may not be used in connection
								with any product or service without the prior written consent of
								Fierce Trade LLC.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Data and Content Ownership
							</h2>
							<p className="text-gray-700 mb-3">
								LoadFetcher aggregates publicly available freight load data from
								various third-party sources. We do not claim ownership of the
								underlying load data. The data is provided for informational
								purposes and to facilitate connections between freight carriers
								and brokers.
							</p>
							<p className="text-gray-700 mb-3">
								You retain all rights to any data or content you upload or
								submit to the Service. By uploading or submitting content, you
								grant us a worldwide, non-exclusive, royalty-free license to
								use, reproduce, and display such content solely for the purpose
								of providing and improving the Service.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Usage Data and Derived Works
							</h2>
							<p className="text-gray-700 mb-3">
								We may collect Service telemetry and usage data (e.g., feature
								usage, search patterns, performance metrics, error logs) and
								create aggregated, anonymized statistics and derived data that
								do not personally identify you.
							</p>
							<p className="text-gray-700 mb-3">
								We may use such aggregated and anonymized data to operate,
								improve, analyze, and market the Service, and we retain all
								rights to such derived works. This usage data is governed by our
								Privacy Policy.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Disclaimer of Warranties; Informational Use; Beta Features
							</h2>
							<p className="text-gray-700 mb-3">
								THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS.
								THE SERVICE IS PROVIDED WITHOUT WARRANTIES OF ANY KIND, WHETHER
								EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED
								WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
								NON-INFRINGEMENT OR COURSE OF PERFORMANCE.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>Informational Use Only:</strong> All outputs provided by
								the Service—including load data, price estimates, route
								recommendations, analytics, AI-generated content, and other
								information—are for informational purposes only. Such outputs
								may be inaccurate, incomplete, or out-of-date, and are not
								legal, financial, compliance, or business advice. You are solely
								responsible for verifying all information and making your own
								business decisions.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>Beta Features:</strong> Features labeled "beta,"
								"preview," "experimental," or similar designations are provided
								"AS IS," may be modified or withdrawn at any time without
								notice, and are excluded from any uptime commitments,
								warranties, or support obligations.
							</p>
							<p className="text-gray-700 mb-3">We do not warrant that:</p>
							<ul className="text-gray-700 mb-3">
								<li>
									The Service will function uninterrupted, secure, or be
									available at any particular time or location
								</li>
								<li>Any errors or defects will be corrected</li>
								<li>
									The Service is free of viruses or other harmful components
								</li>
								<li>
									The results of using the Service will meet your requirements
								</li>
								<li>
									The accuracy, completeness, timeliness, or reliability of any
									load data or information obtained through the Service
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Limitation of Liability
							</h2>
							<p className="text-gray-700 mb-3">
								TO THE MAXIMUM EXTENT PERMITTED BY LAW:
							</p>
							<p className="text-gray-700 mb-3">
								(A) IN NO EVENT WILL FIERCE TRADE LLC, NOR ITS DIRECTORS,
								EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES, BE LIABLE
								FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY,
								OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF
								PROFITS, REVENUE, DATA, USE, GOODWILL, BUSINESS OPPORTUNITIES,
								OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									Your access to or use of or inability to access or use the
									Service
								</li>
								<li>
									Any conduct or content of any third party on or obtained from
									the Service
								</li>
								<li>
									Unauthorized access, use or alteration of your transmissions
									or content
								</li>
								<li>
									Reliance on any information, data, or outputs provided by the
									Service
								</li>
								<li>
									Any interruption, suspension, or termination of the Service
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE)
								OR ANY OTHER LEGAL THEORY, WHETHER OR NOT WE HAVE BEEN INFORMED
								OF THE POSSIBILITY OF SUCH DAMAGE, AND EVEN IF A REMEDY SET
								FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>(B) AGGREGATE LIABILITY CAP:</strong> OUR AGGREGATE
								LIABILITY FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE
								SERVICE OR THESE TERMS WILL NOT EXCEED THE GREATER OF (i) THE
								AMOUNT YOU PAID TO US FOR THE SERVICE IN THE 12 MONTHS
								IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO LIABILITY, OR
								(ii) $100 USD.
							</p>
							<p className="text-gray-700 mb-3">
								THESE LIMITATIONS APPLY TO ANY THEORY OF LIABILITY, INCLUDING
								CONTRACT, TORT, STRICT LIABILITY, OR STATUTORY CLAIMS. SOME
								JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
								CERTAIN DAMAGES; IN SUCH CASES, THE ABOVE LIMITATIONS APPLY TO
								THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Indemnification
							</h2>
							<p className="text-gray-700 mb-3">
								You agree to defend, indemnify and hold harmless Fierce Trade
								LLC and its licensors, and their respective employees,
								contractors, agents, officers and directors, from and against
								any and all claims, damages, obligations, losses, liabilities,
								costs or debt, and expenses (including but not limited to
								reasonable attorney's fees), resulting from or arising out of:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>(a) Your use and access of the Service</li>
								<li>(b) Your violation of any term of these Terms</li>
								<li>
									(c) Your violation of any third party right, including without
									limitation any intellectual property, privacy, or property
									right
								</li>
								<li>
									(d) Your violation of any third-party website's terms of
									service, robots.txt, rate limits, or applicable laws
								</li>
								<li>
									(e) Any claim that your use of the Service caused damage to a
									third party or violated a third party's rights
								</li>
								<li>
									(f) Any negligent or willful misconduct by you or your
									authorized users
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								This indemnification obligation survives termination of these
								Terms and your use of the Service.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								DMCA Policy
							</h2>
							<p className="text-gray-700 mb-3">
								We respond to notices of alleged copyright infringement in
								accordance with the U.S. Digital Millennium Copyright Act (17
								U.S.C. § 512). If you believe that content available through the
								Service infringes your copyright, you may send a written notice
								to our DMCA Agent containing the information required by 17
								U.S.C. § 512(c)(3).
							</p>
							<p className="text-gray-700 mb-3">
								<strong>DMCA Agent Contact:</strong>
								<br />
								Fierce Trade LLC
								<br />
								Attn: DMCA Agent
								<br />
								30 N Gould St. Ste R, Sheridan, WY 82801
								<br />
								Email: info@loadfetcher.com
							</p>
							<p className="text-gray-700 mb-3">
								We may remove or disable access to allegedly infringing content
								and may terminate the accounts of repeat infringers in
								appropriate circumstances.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Export Control and Sanctions Compliance
							</h2>
							<p className="text-gray-700 mb-3">
								You represent and warrant that you are not located in, under the
								control of, or a national or resident of any country or entity
								subject to U.S. embargo, sanctions, or export restrictions
								(including, without limitation, Cuba, Iran, North Korea, Syria,
								and the Crimea region of Ukraine, as may be updated).
							</p>
							<p className="text-gray-700 mb-3">
								You will not use the Service in violation of any U.S. or
								international export control, sanctions, or trade laws or
								regulations, including the U.S. Export Administration
								Regulations (EAR) and regulations administered by the Office of
								Foreign Assets Control (OFAC).
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Dispute Resolution; Binding Arbitration; Class Action Waiver
							</h2>
							<p className="text-gray-700 mb-3">
								<strong>
									PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR LEGAL
									RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT.
								</strong>
							</p>
							<p className="text-gray-700 mb-3">
								You and Fierce Trade LLC agree that any dispute, claim, or
								controversy arising out of or relating to these Terms or the
								Service (including any question regarding existence, validity,
								interpretation, breach, or termination of these Terms) shall be
								resolved by <strong>binding individual arbitration</strong>{' '}
								under the Federal Arbitration Act ("FAA"), administered by the
								American Arbitration Association ("AAA") under its Commercial
								Arbitration Rules or Consumer Arbitration Rules (as applicable
								based on the nature of the claim and the amount in controversy).
							</p>
							<p className="text-gray-700 mb-3">
								The arbitration will be conducted in English. The arbitrator's
								award will be binding and may be entered as a judgment in any
								court of competent jurisdiction. The arbitration will take place
								in Sheridan, Wyoming, or remotely via videoconference or
								telephone, at your option. Each party will bear its own costs
								and attorneys' fees, except as otherwise awarded by the
								arbitrator.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>CLASS ACTION WAIVER:</strong> YOU AND FIERCE TRADE LLC
								AGREE THAT EACH PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN
								AN INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN
								ANY PURPORTED CLASS, CONSOLIDATED, OR REPRESENTATIVE ACTION OR
								PROCEEDING. CLASS ARBITRATIONS, CLASS ACTIONS, PRIVATE ATTORNEY
								GENERAL ACTIONS, AND CONSOLIDATION WITH OTHER ARBITRATIONS ARE
								NOT PERMITTED.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>Exceptions:</strong> Either party may seek relief in a
								small claims court for disputes within that court's
								jurisdiction. Either party may also seek injunctive or other
								equitable relief in a court of competent jurisdiction to prevent
								infringement or misuse of intellectual property rights or
								confidential information, or to address security or abuse
								concerns.
							</p>
							<p className="text-gray-700 mb-3">
								<strong>Opt-Out Right:</strong> You may opt out of this
								arbitration provision within 30 days of first accepting these
								Terms by sending a written notice to info@loadfetcher.com with
								the subject line "Arbitration Opt-Out" and including your name,
								email address, and a clear statement that you wish to opt out of
								the arbitration provision.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Governing Law and Venue
							</h2>
							<p className="text-gray-700 mb-3">
								These Terms shall be governed by and construed in accordance
								with the laws of the State of Wyoming, United States, without
								regard to its conflict of law provisions. To the extent
								arbitration does not apply (including where a party has opted
								out or an exception applies), you agree to submit to the
								exclusive jurisdiction of the state and federal courts located
								in Sheridan County, Wyoming.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Termination
							</h2>
							<p className="text-gray-700 mb-3">
								We may terminate or suspend your account and access to the
								Service immediately, without prior notice or liability, for any
								reason whatsoever, including without limitation if you breach
								these Terms, engage in prohibited use, exceed plan limits,
								initiate chargebacks, or if we believe your use creates risk for
								us or third parties.
							</p>
							<p className="text-gray-700 mb-3">
								Upon termination, your right to use the Service will immediately
								cease. If you wish to terminate your account, you may
								discontinue using the Service or contact us at
								info@loadfetcher.com to request account deletion.
							</p>
							<p className="text-gray-700 mb-3">
								Termination does not relieve you of obligations to pay any
								accrued fees or charges. No refunds will be provided for partial
								billing periods or unused portions of the Service upon
								termination.
							</p>
							<p className="text-gray-700 mb-3">
								All provisions of these Terms which by their nature should
								survive termination shall survive, including without limitation:
								fee obligations, intellectual property provisions, acceptable
								use obligations, warranty disclaimers, indemnification,
								limitations of liability, dispute resolution, and this survival
								clause.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Force Majeure
							</h2>
							<p className="text-gray-700 mb-3">
								We are not liable for any delay or failure to perform any
								obligation under these Terms due to events beyond our reasonable
								control, including but not limited to: acts of God, war,
								terrorism, riots, embargoes, acts of civil or military
								authorities, fire, floods, earthquakes, accidents, pandemics,
								strikes, fuel crises, power outages, or failures or delays in
								services from third-party hosting providers, telecommunications
								providers, or other suppliers.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Assignment
							</h2>
							<p className="text-gray-700 mb-3">
								You may not assign, transfer, or delegate these Terms or any
								rights or obligations hereunder, whether voluntarily or by
								operation of law, without our prior written consent. Any
								attempted assignment in violation of this provision is void.
							</p>
							<p className="text-gray-700 mb-3">
								We may freely assign or transfer these Terms, in whole or in
								part, to any affiliate or in connection with a merger,
								acquisition, corporate reorganization, or sale of all or
								substantially all of our assets, without restriction and without
								notice to you.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Changes to Terms
							</h2>
							<p className="text-gray-700 mb-3">
								We reserve the right, at our sole discretion, to modify or
								replace these Terms at any time. If a revision is material, we
								will provide at least 30 days' notice prior to any new terms
								taking effect by posting a notice on our website, sending an
								email to your registered email address, or by other reasonable
								means.
							</p>
							<p className="text-gray-700 mb-3">
								What constitutes a material change will be determined at our
								sole discretion. For material changes, we may require you to
								re-accept the updated Terms via clickwrap before continuing to
								use the Service.
							</p>
							<p className="text-gray-700 mb-3">
								By continuing to access or use the Service after updated Terms
								become effective, you agree to be bound by the revised Terms. If
								you do not agree to the new Terms, you must stop using the
								Service.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Severability
							</h2>
							<p className="text-gray-700 mb-3">
								If any provision of these Terms is found to be unenforceable or
								invalid under any applicable law, such unenforceability or
								invalidity shall not render these Terms unenforceable or invalid
								as a whole. The unenforceable or invalid provision will be
								modified to the minimum extent necessary to make it enforceable
								and valid, or if that is not possible, such provision shall be
								deleted, and the remaining provisions shall continue in full
								force and effect.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">Waiver</h2>
							<p className="text-gray-700 mb-3">
								Our failure to enforce any right or provision of these Terms
								will not be considered a waiver of those rights or provisions.
								No waiver of any term of these Terms shall be deemed a further
								or continuing waiver of such term or any other term, and our
								failure to assert any right or provision under these Terms shall
								not constitute a waiver of such right or provision.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Entire Agreement and Order of Precedence
							</h2>
							<p className="text-gray-700 mb-3">
								These Terms, together with our Privacy Policy and any other
								incorporated policies, constitute the entire agreement between
								you and us regarding the Service, and supersede and replace any
								prior agreements, understandings, or arrangements between us
								regarding the Service, whether written or oral.
							</p>
							<p className="text-gray-700 mb-3">
								In the event of a conflict: (1) any signed order form or
								addendum takes precedence, then (2) these Terms, then (3)
								incorporated policies (Privacy Policy, etc.).
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								U.S. Government End Users
							</h2>
							<p className="text-gray-700 mb-3">
								The Service and related documentation are "commercial computer
								software" and "commercial computer software documentation" as
								those terms are used in 48 C.F.R. § 2.101. If you are an agency,
								department, or other entity of the United States Government,
								your use, duplication, reproduction, release, modification,
								disclosure, or transfer of the Service or any related
								documentation is restricted in accordance with 48 C.F.R. §
								12.212 (for civilian agencies) and 48 C.F.R. §§ 227.7202 and
								227.7204 (for Department of Defense entities). U.S. Government
								end users acquire the Service and documentation only with those
								rights set forth in these Terms.
							</p>
						</section>

						<h2 className="text-3xl font-bold text-gray-700 mb-3 text-xl">
							Contact Us
						</h2>
						<p className="text-gray-700 mb-3">
							If you have any questions about these Terms and Conditions, You
							can contact us:
						</p>
						<ul className="text-gray-700 mb-3">
							<li>
								<p>By email: info@loadfetcher.com</p>
							</li>

							<li>
								<p>
									By visiting this page on our website:{' '}
									<a
										href="https://loadfetcher.com/terms"
										rel="external nofollow noopener"
										target="_blank"
									>
										https://loadfetcher.com/terms
									</a>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<Footer />
		</div>
	)
}

export default Terms
